export const STORAGE_LANG_KEY = 'preferred_lang';
